// import React from "react";
// import { useLanguage } from "./LanguageContext";

import { useLanguage } from "./LanguageProvider/LanguageProvider";

const MyComponent = () => {
  const { language, switchLanguage } = useLanguage();

  return (
    <div>
      <p>Current Language: {language}</p>
      <button onClick={() => switchLanguage("en")}>English</button>
      <button onClick={() => switchLanguage("uk")}>Українська</button>
    </div>
  );
};

export default MyComponent;
